import React from "react";

export default function SlipDescription(props) {
  if (props.description.length > 0) {
    return <span>{props.description}</span>;
  } else {
    return <span>Ei selitettä</span>;
  }
}
